import styles from './profile-account-setting-section.module.sass';
import classNames from 'classnames/bind';
import TextBlurButton from 'componets/text-blur-button';

const cx = classNames.bind(styles);

export const ProfileAccountSettingListItem = ({ hasBottomBorder, value, label, button = null }) => {
  return (
    <li className={cx('list-item', { 'has-bottom-border': hasBottomBorder })}>
      <div className={cx('list-item-left-part')}>
        <div className={cx('list-item-left-part-label')}>{label}</div>
        <div className={cx('list-item-left-part-value')}>{value}</div>
      </div>
      {button && <TextBlurButton onClick={button.onClick}>{button.content}</TextBlurButton>}
    </li>
  );
};
